<template>
  <div class="c-box-table">
    <table>
      <thead v-if="header.length > 0">
        <tr>
          <th
            v-for="(item, index) in header"
            :key="index"
          >
            <span>
              {{ item.text }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody v-if="body.length > 0">
        <tr
          v-for="(item, index) in body"
          :key="index"
        >
          <td
            v-for="(subItem, subIndex) in item"
            :key="subIndex"
          >
            <span>
              <i
                v-if="displayIcon(subItem)"
                class="fa"
                aria-hidden="true"
                :class="`fa-${ subItem.icon.className }`"
                :style="{ color: iconColor(index) }"
              />
              <span>
                {{ subItem.text }}
              </span>
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="footer.length > 0">
        <tr>
          <td
            v-for="(item, index) in footer"
            :key="index"
          >
            <span>
              {{ item.text }}
            </span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CBoxTable',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    header () {
      return this.data.header || []
    },
    body () {
      return this.data.body || []
    },
    footer () {
      return this.data.footer || []
    }
  },
  methods: {
    displayIcon (item) {
      return item.icon && item.icon.className
    },
    iconColor (index) {
      return this.getNextColor(index)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-box-table {
  overflow-x: auto;
  table {
    width: 100%;
    th, td {
      padding: 2px 2.5px;
      text-align: left;
      vertical-align: middle;
      & > span {
        display: flex;
        padding-left: 20px;
        padding-right: 20px;
        height: 65px;
        font-size: 18px;
        align-items: center;
        background-color: #fff;
        border-radius: 20px;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
        & > i + span {
          padding-left: 14px;
        }
      }
    }
    tfoot {
      td {
        & > span {
          color: #fff;
          background-color: #8aa4af;
        }
        &:first-child {
          & > span {
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
